import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SMORoomUnavailabilityCalendarBaloon from './SMORoomUnavailabilityCalendarBaloon';
import SMConst from 'lib/SMConst';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMCalendarHelper from 'components/helpers/SMCalendarHelper';

class SMORoomUnavailabilityCalendarCell extends React.Component {
  
  cellDidClick(e) {
    e.preventDefault();
    let selectedDate = SMCalendarHelper.cellItemToDate(this.props.item),
        baloon = <SMORoomUnavailabilityCalendarBaloon
          selectedDate={selectedDate}
          clientX={e.clientX}
          clientY={e.clientY}
          room={this.props.room}
          plan={this.props.plan}
          delegate={this.props.delegate} />;
    
    ReactDOM.render(baloon, document.getElementById('js-baloon-container'));
  }
  
  itemDidClick(itemType, item, e) {
    e.stopPropagation();
    switch (itemType) {
      case SMConst.CalendarItemType.Holiday:
        if(this.props.delegate && typeof this.props.delegate.holidayDidClick === 'function') {
          this.props.delegate.holidayDidClick();
        }
        break;
      case SMConst.CalendarItemType.Unavailability:
        let selectedDate = SMCalendarHelper.cellItemToDate(this.props.item),
            baloon = <SMORoomUnavailabilityCalendarBaloon
              selectedDate={selectedDate}
              item={item}
              clientX={e.clientX}
              clientY={e.clientY}
              room={this.props.room}
              plan={this.props.plan}
              delegate={this.props.delegate} />;
        
        ReactDOM.render(baloon, document.getElementById('js-baloon-container'));
        break;
      case SMConst.CalendarItemType.ExternalServiceItem:
        window.open(item.url);
        break;
    }
  }
  
  renderInnerHtml(item) {
    
    if (item.status == SMConst.RoomStatus.Close) {
      return <p onClick={this.itemDidClick.bind(this, SMConst.CalendarItemType.Holiday, null)} className="dashboard-calendar__content-paragraph">利用不可</p>;
    } else {
      let innerCellItems = [];
      for (let i=0; i < item.unavailabilities.length; i++) {
        let unavailability = item.unavailabilities[i];
        if (unavailability.is_blocked) {
          innerCellItems.push(
            <p key={"unavailability-"+unavailability.id} 
              className="dashboard-calendar__content-paragraph" 
              onClick={this.itemDidClick.bind(this, SMConst.CalendarItemType.Unavailability, unavailability)}>
              <i className="fa fa-times"></i>{SMFormatHelper.unavailabilityText(unavailability, 'calendar')}
            </p>
          );
        } else {
          if (unavailability.is_all_day) innerCellItems = [];
        }
      }
      
      for (let i=0; i < item.imported_schedules.length; i++) {
        let displayDates = '';
        if (item.imported_schedules[i].duration == 1440) {
          displayDates = '終日';
        } else {
          let startedAt = new Date(item.imported_schedules[i].started_at),
              endedAt = new Date(Date.parse(item.imported_schedules[i].started_at) + item.imported_schedules[i].duration * 60 * 1000);
          displayDates = I18n.l('date.hm', startedAt) + '-' + I18n.l('date.hm', endedAt);
        }
        innerCellItems.push(
          <p key={"imported_schedules-"+item.imported_schedules[i].id} 
            className="dashboard-calendar__content-paragraph" 
            onClick={this.itemDidClick.bind(this, SMConst.CalendarItemType.ExternalServiceItem, item.imported_schedules[i])}>
            <i className="fa fa-times"></i>{displayDates}<span className="dashboard-calendar__content-value">　{item.imported_schedules[i].title}</span>
          </p>
        );
      }

      return innerCellItems;
    }
  }
  
  render() {
    if (SMCalendarHelper.isPast(this.props.item, this.props.today)) {
      return(
        <td className={SMCalendarHelper.cellClassName(this.props.item, this.props.year, this.props.month, this.props.today)}>
          <div className="dashboard-calendar__cell-wrap">
             <p className="dashboard-calendar__date">{this.props.item.day}</p>
             <div className="dashboard-calendar__content"></div>
          </div>
        </td>
      );
    } else {
      return(
        <td className={SMCalendarHelper.cellClassName(this.props.item, this.props.year, this.props.month, this.props.today)}>
          <a href="#" className="dashboard-calendar__cell-wrap" 
            onClick={SMCalendarHelper.isClosed(this.props.item) ? null : this.cellDidClick.bind(this)}>
            <p className="dashboard-calendar__date">{this.props.item.day}</p>
            <div className="dashboard-calendar__content is-unavailable">
              {this.renderInnerHtml(this.props.item)}
            </div>
          </a>
        </td>
      );
    }
  }
}

SMORoomUnavailabilityCalendarCell.propTypes = {
  item: PropTypes.object.isRequired,
  today: PropTypes.instanceOf(Date).isRequired,
  delegate: PropTypes.object,
  room: PropTypes.object,
  plan: PropTypes.object,
};

export default SMORoomUnavailabilityCalendarCell;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/calendar/SMORoomUnavailabilityCalendarCell.jsx